const toggleFaq = (element) => {
    const answer = element.nextElementSibling;
    const answerHeight = answer.scrollHeight;

    if (answer.style.maxHeight) {
        answer.style.maxHeight = null;
        answer.style.padding = "0 0 0 0";
    } else {
        answer.style.maxHeight = answerHeight + "px";
        answer.style.padding = "0 0 0 0";
    }

    element.classList.toggle('active');
}

const faqs = document.querySelectorAll('.horizon-faq__question');
if( faqs) {
    faqs.forEach( faq => {
        faq.addEventListener( 'click', (e) => {
            toggleFaq(e.target);
        })
    })
}